import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Divider, Typography } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import MarketOrderSellForm from "../sellTypesform/MarketOrderSellForm";
import LimitOrderSellForm from "../sellTypesform/LimitOrderSellForm";
import StopLimitOrderSellForm from "../sellTypesform/StopLimitOrderSellForm";
// import MarketOrderSellForm from "../sellTypesForm/MarketOrderBuyForm";
// import LimitOrderSellForm from "../sellTypesForm/LimitOrderSellForm";
// import StopLimitOrderBuyForm from "../sellTypesForm/StopLimitOrderSellForm";

const SellOrderTypeTab = React.memo((props) => {
	const { coinPrice, coinSymbol } = props;
	console.log(coinPrice);
	const [value, setValue] = React.useState("1");

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<Box sx={{ width: "100%", typography: "body1" }}>
			<TabContext value={value}>
				<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
					<TabList onChange={handleChange} aria-label="lab API tabs example">
						<Tab label="Market Order" value="1" />
						{/* <Tab label="Sell Limit" value="2" />
						<Tab label="sell Stop " value="3" /> */}
						{/* <Tab label="Recent investmet" value="4" /> */}
					</TabList>
				</Box>
				<TabPanel value="1">
					<MarketOrderSellForm coinPrice={coinPrice} coinSymbol={coinSymbol} />
				</TabPanel>
				{/* <TabPanel value="2">
					<LimitOrderSellForm coinPrice={coinPrice} coinSymbol={coinSymbol} />
				</TabPanel>
				<TabPanel value="3">
					<StopLimitOrderSellForm />
				</TabPanel> */}
			</TabContext>
		</Box>
	);
});

export default SellOrderTypeTab;
